import React from 'react';

export const Footer = () => {
    const year = new Date().getFullYear();
    return <footer><p className='text-center h6 mb-5'>{year} TTEC. All rights reserved</p></footer>;
};
